import RenderStaffPermission from "components/settings/staff-permission";
import React from "react";

export default function StaffPermission() {
  return <RenderStaffPermission />;
}
